import React, {useEffect, useState} from "react";
import {
  Button,
  Container,
  Dialog,
  Grid,
  Typography
} from "@mui/material";
import { Grid as DataGrid, GridColumn } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import FrequencyDropDown from "../frequency-dropdown";
import AddIcon from "@mui/icons-material/Add";
import {CurrencyCell} from "../currency-cell";
import DeleteIcon from "@mui/icons-material/Delete";
import {collectErrorMessages, getCurrentYear} from "../../shared/shared";
import YearCell from "../year-cell";
import { Input } from "@progress/kendo-react-inputs";
import InfoIcon from "@mui/icons-material/Info";
import ValidationSignCell from "../validation-sign-cell";
import IconButton from "@mui/material/IconButton";
import ErrorIcon from "@mui/icons-material/Error";
import {StyledTooltip} from "../../pages/plan-inputs";

const AdditionalInformation = (props) => {

  const close = (e) => {
    props.save();
  }

  const handleChange = (valueChange, idQuestion, valueAnswers) => {

    AdditionalInformation.updateAdditional({
      answer: valueChange.target.value,
      clientQuestionId: valueAnswers === undefined ? null : valueAnswers.clientQuestionId,
      questionId: idQuestion,
      editIndex: valueAnswers === undefined ? null : valueAnswers.editIndex
    })
  }

  return (
    <Container>

      <Grid container>
        <Grid item xs={12}>
          <Typography component={"h1"}>Goals Additional Information</Typography>
        </Grid>
        <Grid container spacing={3} >
          {props.questions.map(e => {
            const valueAnswers = props.answers.find((answer) => answer?.questionId === e.id)
            return (
              <Grid key={e.id} item xs={12}>
                <Input
                  onChange={(valueChange) => { handleChange(valueChange, e.id, valueAnswers) }}
                  value={valueAnswers?.answer}
                  label={e.question} />
              </Grid>)
          })}
        </Grid>
      </Grid>

      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '30px 0' }}>
        <Button m={'0'} onClick={close}>close</Button>
      </div>
    </Container >
  );
};

const CommandCell = (deleteFn) => {
  return (props) => {
    const dataItem = props.dataItem;

    return (
      <td>
        <DeleteIcon
          onClick={() => {
            deleteFn(dataItem);
          }}
        />
      </td>
    );
  };
};

const Goals = (props) => {
  const [state, setState] = useState({
    sort: [
      {
        field: "firstName",
        dir: "asc",
      },
    ],
    page: { skip: 0, take: 10 },
    errorMessages: [],
  });

  useEffect(() => {
    setState({
      ...state,
      errorMessages: collectErrorMessages(props.validations.goals, "goal"),
    })
  }, [props.validations.goals]);

  const addGoal = () => {
    const prototype = {
      id: null,
      editIndex: 0,
      inEdit: true,
      amount: 0,
      endYear: getCurrentYear(),
      incomeType: "PENSION",
      frequency: "MONTHLY",
      startYear: getCurrentYear(),
    };

    props.addGoal(prototype);
  };
  const saveAdditionalInfo = () => {
    setState({
      ...state,
      showAdditionalInformationModal: false,
    });
  };

  const cancelAdditionalInfo = () => {
    setState({
      ...state,
      showAdditionalInformationModal: false,
    });
  };

  AdditionalInformation.updateAdditional = props.updateAdditional;

  const goals = props.goals.map((item, index) => {
    const validation = props.validations.goals[index];
    let isValid = true;
    if (validation) {
      Object.keys(validation).forEach((key) => {
        if (!validation[key].valid) isValid = false;
      });
    }
    return {
      ...item,
      inEdit: props.readOnly ? false : true,
      isValid: isValid
    }
  });

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} display={'flex'} alignItems={'center'}>
        <Typography component={"h1"}>Goals</Typography>
        <InfoIcon
          style={{ paddingLeft: '10px' }}
          onClick={() => {
            setState({
              ...state,
              showAdditionalInformationModal: true,
            });
          }}
        />

      </Grid>
      <Grid item xs={12}>
        {(!props.readOnly && state.errorMessages.length > 0) && (
          <div className="error-tooltip-wrapper">
              <StyledTooltip
                  arrow
                  className="error-tooltip"
                  placement="right"
                  title={
                    <ul className="error-tooltip-ul">{
                      state.errorMessages.map((e, idx) => {
                        return (
                            <li key={idx}>
                              <Typography
                                  className={'default-font'}
                                  textAlign={'left'}
                                  variant={'span'}> {e}
                              </Typography>
                            </li>
                        );
                      })}
                    </ul>
                  }
              >
                <IconButton>
                  <ErrorIcon />
                </IconButton>
              </StyledTooltip>
          </div>
        )}
        {!props.readOnly && <Button onClick={addGoal}>
          <AddIcon />
          Add Goal
        </Button>}
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          data={orderBy(goals, state.sort).slice(
            state.page.skip,
            state.page.take + state.page.skip
          )}
          skip={state.page.skip}
          take={state.page.take}
          total={props.goals.length}
          pageable={true}
          onPageChange={(event) => {
            setState({
              ...state,
              page: event.page,
            });
          }}
          scrollable={"none"}
          editField={"inEdit"}
          onItemChange={(event) => {
            props.update(event.field)(event.dataItem, event.value);
          }}
        >
          <GridColumn title={" "} field={"isValid"} cell={ValidationSignCell} />
          <GridColumn
            title={"Frequency"}
            field={"frequency"}
            cell={FrequencyDropDown}
          />
          <GridColumn title={"Amount"} field={"amount"} cell={CurrencyCell} />
          <GridColumn title={"Start Year"} field={"startYear"} cell={YearCell} />
          <GridColumn title={"End Year"} field={"endYear"} cell={YearCell} />
          {!props.readOnly && <GridColumn title={" "} cell={CommandCell(props.delete)} />}
        </DataGrid>
      </Grid>
      {state.showAdditionalInformationModal && (
        < Dialog
          fullWidth={true}
          maxWidth={"lg"}

          open={state.showAdditionalInformationModal}
          onClose={() => {
            setState({
              ...state,
              showAdditionalInformationModal: false,
            });
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <AdditionalInformation
            save={saveAdditionalInfo}
            questions={props.questions}
            answers={props.answers}
          />
        </Dialog>
      )}
    </Grid>
  );
};

export default Goals;
